<div class="menu-vertical" [class.menu-aberto]="menu">
  <fa-icon
    class="icon-menu-fechar"
    [icon]="iconMenuFechar"
    (click)="btMenuChange()"
  ></fa-icon>

  <ul>
    <li
      *ngFor="let menu of menusUsuario; let index = index"
      [routerLink]="menu.rota"
      [class.desabilitado]="menu.desabilitar"
      [class.li-menu-aberto]="menu.click"
      [class.marcado]="menu.active"
      [class.menuConfig]="menu.itemMenu == 'CONFIGURACAO'"
      (click)="openCloseSubMenu(menu)"
      id="menu-lateral-{{ menu.itemMenu }}"
    >
      <div class="d-flex flex-column d-flex-align-items-center menu__lateral">
        <fa-icon
          (click)="verificaPermissaoIcon(menu)"
          [icon]="iconeSvg(menu.class)"
          class="menu-click-js d-flex icone__menu__lateral"
        ></fa-icon>
      </div>
      <span class="tooltip-menu" [class.tooltip-menu-aberto]="menu.click">{{
        menu?.descricao
      }}</span>
      <span class="menu-titulo menu-click-js" [class.marcado]="menu.click">{{
        menu?.descricao
      }}</span>
    </li>
  </ul>
</div>
